import { useEffect } from "react";
import { useNavigate } from "react-router";

import { EndorsementRoutes, navigateToEndorsementStep } from "@routing/paths";

export const useLockUnderwritingFailed = (
  isUnderwritingFailed: boolean,
  currentStep: EndorsementRoutes,
  policyLocator: string,
  endorsementId: string | null
) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isUnderwritingFailed || currentStep !== EndorsementRoutes.CHECKOUT) {
      return;
    }

    navigateToEndorsementStep(
      navigate,
      policyLocator,
      EndorsementRoutes.UW_REVIEW,
      { endorsementId, replace: true }
    );
  }, [isUnderwritingFailed, currentStep, policyLocator, endorsementId]);
};
